const INDEX_CONTAINER_CLASSNAME = '.syllabuses'
import Sortable from "sortablejs"

$(document).on('turbolinks:load', function() {
  $(".bulk-task").attr("disabled", true);

  var el = $('#selected_template_list');

  if(el.length != 0) {
    var sortable = new Sortable(el[0], {
      onUpdate: function (/**Event*/evt) {
        $.ajax({
          url: "update_template_list",
          method: "POST",
          data: { template_ids: sortable.toArray(), type: "sort" },
          success: (response) => {
          },
          error: function(response) {
            console.log('Something went wrong. Please try again.');
          }
        });
      },
    
    });
  }

  $('#template-select').select2({
    ajax: {
      url: '/assignment_templates_search.json',
      dataType: 'json',
    },
    templateResult: function (res) {
      var $container = null
      $container = $("<div id=template-"+res.id+">" + res.text + "</div>");

      return $container;
    }
  });

  $('body').on('click', '.remove-selected-template', function() {
    var id = this.id

    $.ajax({
      url: "update_template_list",
      method: "POST",
      data: { template_id: id, type: "delete" },
      success: (response) => {
        $('#selected_template_list #template-' + id).remove();
      },
      error: function(response) {
        console.log('Something went wrong. Please try again.');
      }
    });
  });

  $("#template-select").change(function(){
    var obj = $(this).select2('data')[0];

    var list_div = "<li class='list-group-item d-flex justify-content-between align-items-center' data-id='"+obj.id+"' id='template-"+obj.id+"'>"+obj.text+"<button class='btn remove-selected-template' id='"+obj.id+"'><i class='fa fa-trash' aria-hidden='true'></i></button></li>"
    
    $.ajax({
      url: "update_template_list",
      method: "POST",
      data: { template_id: obj.id, type: "add" },
      success: (response) => {
        $("#selected_template_list").append(list_div)
      },
      error: function(response) {
        alert("Task already added to the list")
      }
    });

  });

  const table_row_checkbox = INDEX_CONTAINER_CLASSNAME + ' .row-checkbox';

  $('body').on('click', table_row_checkbox, function() {
    if ($(table_row_checkbox + ":checked").length > 0){
      $(".bulk-task").attr("disabled", false);
    } else {
      $(".bulk-task").attr("disabled", true);
    }
  });

  $(INDEX_CONTAINER_CLASSNAME + ' .bulk-delete').click(function() {
    var ids = []
    $(table_row_checkbox + ':checked').each(function(i, obj){
      ids.push(obj.id)
    })

    if (confirm('Delete all selected syllabuses?')){
      $.ajax({
        url: "/syllabuses/bulk_delete",
        method: "DELETE",
        data: { syllabus_ids: ids },
        success: (response) => {
          location.reload();
        },
        error: function(response) {
          console.log('Something went wrong. Please try again.');
        }
      });
    }
    else {
      return false;
    }
  });

  $(INDEX_CONTAINER_CLASSNAME + ' .bulk-clone').click(function() {
    var ids = []
    $(table_row_checkbox + ':checked').each(function(i, obj){
      ids.push(obj.id)
    })

    if (confirm('Clone all selected syllabuses?')){
      $.ajax({
        url: "/syllabuses/bulk_clone",
        method: "POST",
        data: { syllabus_ids: ids},
        success: (response) => {
          setTimeout(function(){ location.reload() }, 1000);
        },
        error: function(response) {
          console.log('Something went wrong. Please try again.');
        }
      });
    }
    else {
      return false;
    }

  });

  $(INDEX_CONTAINER_CLASSNAME + ' #tag_select').change(function(){
    let url = new URL(window.location.href);
    var val = $(this).val()

    if(val.length != 0){
      url.searchParams.set('tags', val.join(","))
    } else {
      url.searchParams.delete('tags')
    }

    window.location.href = url.href;
  });

});